import { Injectable } from '@angular/core';
import { ProductServiceService } from './product-service.service';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {

  trending_status= 'TRENDING';
  new_status = 'NEW';
  old_status = 'OLD';
  popular_status = 'POPULAR';
  singleProductsItem = [];

  constructor(private productServiceService:ProductServiceService) {
      productServiceService.getAllDetails().subscribe(res=>{
        this.singleProductsItem = res;
      })

   }

  
  getProductsByStatus(status:any){
    const newProducts = this.singleProductsItem.filter(product => product.status === status);

// Log the array of new products to the console
    console.log('New Prosucts len '+newProducts.length);
    return newProducts;
  }

  getDetails(itemId:any){
    const selectedItem = this.singleProductsItem.find(item => item.id === itemId);

    // Do something with the selected item, such as displaying its details
    console.log("selected Item details "+JSON.stringify(selectedItem));
    return selectedItem;
  }

  getProductsInTitle(title:any){
    const matchingItems = this.singleProductsItem.filter(item => item.title.toLowerCase().includes(title.toLowerCase()));

    if (matchingItems.length === 0) {
        console.log("No matching items found for the provided title.");
        return matchingItems;
    }

    return matchingItems;
  }

  returnAllProducts(){
    return this.singleProductsItem;
  }

}